import React, { useState } from 'react';
import moment from 'moment';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

const DateInput = props => {
  const { id, name, value, handleUpdate, getInitialValue, edited, disabled } = props;

  const parseDate = val => {
    if (!val) return null;
    const m = moment(val, ['MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
    return m.isValid() ? m.toDate() : null;
  };

  const [fieldValue, setFieldValue] = useState(parseDate(value));
  return (
    <Form.Group controlId={id}>
      <DatePicker
        className={`form-control ${edited ? 'edited' : ''}`}
        format="MM/DD/YYYY"
        onKeyDown={e => {
          e.preventDefault();
        }}
        selected={fieldValue}
        onChange={date => {
          const initDate = getInitialValue(id, name);
          setFieldValue(date || initDate);
          handleUpdate(date ? moment(date).format('YYYY-MM-DD') : initDate);
        }}
        placeholderText={fieldValue ? '' : '-'}
        disabled={disabled}
        isClearable={!disabled}
      />
    </Form.Group>
  );
};

export default DateInput;
